
export const useBanner = () => {
  const rootStore = useRootStore()

  let pageBannerData = null

  onBeforeMount(() => {
    if (pageBannerData) {
      nextTick(() => rootStore.SET_PAGE_BANNER(pageBannerData))
    }
  })

  const setPageBanner = (bannerData, onlyClient) => {
    if (!onlyClient && import.meta.server) {
      rootStore.SET_PAGE_BANNER(bannerData)
      return
    }

    pageBannerData = bannerData
  }

  return {
    setPageBanner,
  }
}
